import { render, staticRenderFns } from "./expertSurgery.vue?vue&type=template&id=72323c1b&scoped=true"
import script from "./expertSurgery.vue?vue&type=script&lang=js"
export * from "./expertSurgery.vue?vue&type=script&lang=js"
import style0 from "./expertSurgery.vue?vue&type=style&index=0&id=72323c1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72323c1b",
  null
  
)

export default component.exports